export default {
  // GET Requests //

  // Gets all data in training
  async getTrainingData(context) {
    const token = context.rootGetters["authData/token"];
    const companyId = context.rootGetters["userData/companyId"];

    let modules;
    let learning;
    let competency;

    try {
      modules = await fetch(
        process.env.VUE_APP_NODE_SERVER +
          "/training-modules/retrieve-by-company/" +
          companyId,
        {
          method: "GET",
          headers: { Authorization: "Bearer " + token },
        }
      );
      modules = await modules.json();

      learning = await fetch(
        process.env.VUE_APP_NODE_SERVER +
          "/learning-content/retrieve-by-company/" +
          companyId,
        {
          method: "GET",
          headers: { Authorization: "Bearer " + token },
        }
      );
      learning = await learning.json();

      competency = await fetch(
        process.env.VUE_APP_NODE_SERVER +
          "/competency-tests/retrieve-by-company/" +
          companyId,
        {
          method: "GET",
          headers: { Authorization: "Bearer " + token },
        }
      );
      competency = await competency.json();
    } catch (err) {
      return 500;
    }

    // create learning object
    context.commit("learningContent", learning.learningContent);

    // create competency object
    var competencyObject = [];
    competency.competencyTests.forEach((test) => {
      let tasks = [];
      for (let i = 0; i < test.tasks.length; i++) {
        tasks.push({
          taskId: test.tasks[i].taskId,
          title: test.tasks[i].title,
        });
      }

      competencyObject.push({
        competencyId: test.competencyId,
        moduleId: test.moduleId,
        title: test.title,
        published: test.published,
        supervisorId: test.supervisorId,
        description: test.description,
        timeframeValue: test.timeframeValue,
        timeframeUnit: test.timeframeUnit,
        tasks: tasks,
        lastModified: test.lastModified,
        created: test.created,
      });
    });
    context.commit("competencyTests", competencyObject);

    // Create modules object
    var modulesObject = [];
    modules.modules.forEach((module) => {
      modulesObject.push({
        moduleId: module.moduleId,
        type: module.type,
        title: module.title,
        timeframeValue: module.timeframeValue,
        timeframeUnit: module.timeframeUnit,
        moduleReview: module.moduleReview,
        userId: module.userId,
        points: module.points || 0,
        audience: module.audience || "public",
        locations: module.locations,
        departments: module.departments,
        moduleImageSource: module.moduleImageSource || null,
        lastModified: module.lastModified,
        created: module.created,
      });

      if (Number(module.moduleReview) < new Date().getTime() / 1000) {
        context.commit("addRequiredAction", {
          id: "MR-" + String(Math.floor(Math.random() * (999 - 100 + 1) + 100)),
          type: "module_review",
          moduleId: module.moduleId,
          title: module.title,
          date: module.moduleReview,
        });
      }
    });
    context.commit("modules", modulesObject);
    context.commit("trainingTimestamp");

    return 200;
  },

  // Gets all enrollments by company
  async getEnrollments(context) {
    const token = context.rootGetters["authData/token"];
    const modules = context.state.modules;
    var moduleIds = [];
    for (let i = 0; i < modules.length; i++) {
      moduleIds.push(modules[i].moduleId);
    }

    const users = context.rootGetters["userData/companyUsers"];
    var userIds = [];
    for (let i = 0; i < users.length; i++) {
      userIds.push(users[i].userId);
    }

    let response;

    try {
      response = await fetch(
        process.env.VUE_APP_NODE_SERVER +
          "/training-enrollments/retrieve-by-modules/" +
          JSON.stringify(moduleIds) +
          "/" +
          JSON.stringify(userIds),
        {
          method: "GET",
          mode: "cors",
          headers: { Authorization: "Bearer " + token },
        }
      );
      response = await response.json();
    } catch (err) {
      return 500;
    }

    var enrollmentsObject = [];
    response.enrollments.forEach((enrollment) => {
      var totalCompleted = 0;

      // Create learning object
      var learning = [];
      var completedLearnings = true;
      for (let i = 0; i < enrollment.learningContent.length; i++) {
        if (
          context.state.learningContent.find(
            (learning) =>
              learning.learningId == enrollment.learningContent[i].learningId
          )
        ) {
          learning.push({
            learningId: enrollment.learningContent[i].learningId,
            status: enrollment.learningContent[i].status,
            completedTimestamp:
              enrollment.learningContent[i].completedTimestamp || null,
            created: enrollment.learningContent[i].created,
          });
          if (enrollment.learningContent[i].status == "completed") {
            totalCompleted = totalCompleted + 1;
          } else {
            completedLearnings = false;
          }
        }
      }

      // Create comptency object
      var competency = [];
      for (let i = 0; i < enrollment.competencyTests.length; i++) {
        if (
          context.state.competencyTests.find(
            (competency) =>
              competency.competencyId ==
              enrollment.competencyTests[i].competencyId
          )
        ) {
          let latestTestIndex = 0;
          let lastestTestTimestamp = Number(
            enrollment.competencyTests[i].tests[0].created
          );
          for (let j = 0; j < enrollment.competencyTests[i].tests.length; j++) {
            if (
              Number(enrollment.competencyTests[i].tests[j].created) >
              lastestTestTimestamp
            ) {
              latestTestIndex = j;
              lastestTestTimestamp = Number(
                enrollment.competencyTests[i].tests[j].created
              );
            }
          }

          var vacantMeetings = false;
          var tasks = [];
          for (
            let j = 0;
            j <
            enrollment.competencyTests[i].tests[latestTestIndex].tasks.length;
            j++
          ) {
            tasks.push({
              taskId:
                enrollment.competencyTests[i].tests[latestTestIndex].tasks[j]
                  .taskId,
              dateReviewed:
                enrollment.competencyTests[i].tests[latestTestIndex].tasks[j]
                  .dateReviewed,
              meetingId:
                enrollment.competencyTests[i].tests[latestTestIndex].tasks[j]
                  .meetingId,
              completedTimestamp:
                enrollment.competencyTests[i].tests[latestTestIndex].tasks[j]
                  .completedTimestamp,
            });

            if (
              !enrollment.competencyTests[i].tests[latestTestIndex].tasks[j]
                .meetingId
            ) {
              vacantMeetings = true;
            }
          }

          var attachments = [];
          for (
            let j = 0;
            j <
            enrollment.competencyTests[i].tests[latestTestIndex].attachments
              .length;
            j++
          ) {
            attachments.push(
              enrollment.competencyTests[i].tests[latestTestIndex].attachments[
                j
              ]
            );
          }

          competency.push({
            competencyId: enrollment.competencyTests[i].competencyId,
            status: enrollment.competencyTests[i].status,
            supervisorId:
              enrollment.competencyTests[i].tests[latestTestIndex].supervisorId,
            supervisorFullName:
              enrollment.competencyTests[i].tests[latestTestIndex]
                .supervisorFullName,
            completedTimestamp:
              enrollment.competencyTests[i].tests[latestTestIndex]
                .completedTimestamp,
            expectedReviewDate:
              enrollment.competencyTests[i].tests[latestTestIndex]
                .expectedReviewDate,
            tasks: tasks,
            attachments: attachments,
            comments:
              enrollment.competencyTests[i].tests[latestTestIndex].comments ||
              null,
            created:
              enrollment.competencyTests[i].tests[latestTestIndex].created,
          });

          if (enrollment.competencyTests[i].status == "completed") {
            totalCompleted = totalCompleted + 1;
          }

          if (
            completedLearnings &&
            vacantMeetings &&
            enrollment.competencyTests[i].status != "completed" &&
            Number(
              enrollment.competencyTests[i].tests[latestTestIndex]
                .expectedReviewDate
            ) <
              new Date().getTime() / 1000 + 604800
          ) {
            context.commit("addRequiredAction", {
              id:
                "CR-" +
                String(Math.floor(Math.random() * (999 - 100 + 1) + 100)),
              type: "competency_no_meeting",
              moduleId: enrollment.moduleId,
              enrollmentId: enrollment.enrollmentId,
              competencyId: enrollment.competencyTests[i].competencyId,
              userId: enrollment.userId,
              date: enrollment.competencyTests[i].tests[latestTestIndex]
                .expectedReviewDate,
            });
          }
        }
      }

      enrollmentsObject.push({
        enrollmentId: enrollment.enrollmentId,
        moduleId: enrollment.moduleId,
        userId: enrollment.userId,
        totalCompleted: totalCompleted,
        expectedCompletion: enrollment.expectedCompletion,
        completedTimestamp: enrollment.completedTimestamp,
        learningContent: learning,
        competencyTests: competency,
        created: enrollment.created,
      });
    });
    context.commit("enrollments", enrollmentsObject);
    context.commit("enrollmentsLoaded");

    return 200;
  },
  // Gets all enrollments by user
  async getEnrollmentsByUser(context) {
    const token = context.rootGetters["authData/token"];

    const userId = context.rootGetters["userData/userId"];

    let response;

    try {
      response = await fetch(
        process.env.VUE_APP_NODE_SERVER +
          "/training-enrollments/retrieve-by-user/" +
          userId,
        {
          method: "GET",
          mode: "cors",
          headers: { Authorization: "Bearer " + token },
        }
      );
      response = await response.json();
    } catch (err) {
      return 500;
    }

    var enrollmentsObject = [];
    response.enrollments.forEach((enrollment) => {
      var totalCompleted = 0;

      // Create learning object
      var learning = [];
      var completedLearnings = true;
      for (let i = 0; i < enrollment.learningContent.length; i++) {
        if (
          context.state.learningContent.find(
            (learning) =>
              learning.learningId == enrollment.learningContent[i].learningId
          )
        ) {
          learning.push({
            learningId: enrollment.learningContent[i].learningId,
            status: enrollment.learningContent[i].status,
            completedTimestamp:
              enrollment.learningContent[i].completedTimestamp || null,
            created: enrollment.learningContent[i].created,
          });
          if (enrollment.learningContent[i].status == "completed") {
            totalCompleted = totalCompleted + 1;
          } else {
            completedLearnings = false;
          }
        }
      }

      // Create comptency object
      var competency = [];
      for (let i = 0; i < enrollment.competencyTests.length; i++) {
        if (
          context.state.competencyTests.find(
            (competency) =>
              competency.competencyId ==
              enrollment.competencyTests[i].competencyId
          )
        ) {
          let latestTestIndex = 0;
          let lastestTestTimestamp = Number(
            enrollment.competencyTests[i].tests[0].created
          );
          for (let j = 0; j < enrollment.competencyTests[i].tests.length; j++) {
            if (
              Number(enrollment.competencyTests[i].tests[j].created) >
              lastestTestTimestamp
            ) {
              latestTestIndex = j;
              lastestTestTimestamp = Number(
                enrollment.competencyTests[i].tests[j].created
              );
            }
          }

          var vacantMeetings = false;
          var tasks = [];
          for (
            let j = 0;
            j <
            enrollment.competencyTests[i].tests[latestTestIndex].tasks.length;
            j++
          ) {
            tasks.push({
              taskId:
                enrollment.competencyTests[i].tests[latestTestIndex].tasks[j]
                  .taskId,
              dateReviewed:
                enrollment.competencyTests[i].tests[latestTestIndex].tasks[j]
                  .dateReviewed,
              meetingId:
                enrollment.competencyTests[i].tests[latestTestIndex].tasks[j]
                  .meetingId,
              completedTimestamp:
                enrollment.competencyTests[i].tests[latestTestIndex].tasks[j]
                  .completedTimestamp,
            });

            if (
              !enrollment.competencyTests[i].tests[latestTestIndex].tasks[j]
                .meetingId
            ) {
              vacantMeetings = true;
            }
          }

          var attachments = [];
          for (
            let j = 0;
            j <
            enrollment.competencyTests[i].tests[latestTestIndex].attachments
              .length;
            j++
          ) {
            attachments.push(
              enrollment.competencyTests[i].tests[latestTestIndex].attachments[
                j
              ]
            );
          }

          competency.push({
            competencyId: enrollment.competencyTests[i].competencyId,
            status: enrollment.competencyTests[i].status,
            supervisorId:
              enrollment.competencyTests[i].tests[latestTestIndex].supervisorId,
            supervisorFullName:
              enrollment.competencyTests[i].tests[latestTestIndex]
                .supervisorFullName,
            completedTimestamp:
              enrollment.competencyTests[i].tests[latestTestIndex]
                .completedTimestamp,
            expectedReviewDate:
              enrollment.competencyTests[i].tests[latestTestIndex]
                .expectedReviewDate,
            tasks: tasks,
            attachments: attachments,
            comments:
              enrollment.competencyTests[i].tests[latestTestIndex].comments ||
              null,
            created:
              enrollment.competencyTests[i].tests[latestTestIndex].created,
          });

          if (enrollment.competencyTests[i].status == "completed") {
            totalCompleted = totalCompleted + 1;
          }

          if (
            completedLearnings &&
            vacantMeetings &&
            enrollment.competencyTests[i].status != "completed" &&
            Number(
              enrollment.competencyTests[i].tests[latestTestIndex]
                .expectedReviewDate
            ) <
              new Date().getTime() / 1000 + 604800
          ) {
            context.commit("addRequiredAction", {
              id:
                "CR-" +
                String(Math.floor(Math.random() * (999 - 100 + 1) + 100)),
              type: "competency_no_meeting",
              moduleId: enrollment.moduleId,
              enrollmentId: enrollment.enrollmentId,
              competencyId: enrollment.competencyTests[i].competencyId,
              userId: enrollment.userId,
              date: enrollment.competencyTests[i].tests[latestTestIndex]
                .expectedReviewDate,
            });
          }
        }
      }

      enrollmentsObject.push({
        enrollmentId: enrollment.enrollmentId,
        moduleId: enrollment.moduleId,
        userId: enrollment.userId,
        totalCompleted: totalCompleted,
        expectedCompletion: enrollment.expectedCompletion,
        completedTimestamp: enrollment.completedTimestamp,
        learningContent: learning,
        competencyTests: competency,
        created: enrollment.created,
      });
    });
    context.commit("enrollments", enrollmentsObject);
    context.commit("enrollmentsLoaded");

    return 200;
  },
  // POST Requests //

  // Gets all data in training
  async postTrainingModule(context, payload) {
    const token = context.rootGetters["authData/token"];
    const companyId = context.rootGetters["userData/companyId"];
    const userId = context.rootGetters["userData/userId"];
    let response;
    try {
      response = await fetch(
        process.env.VUE_APP_NODE_SERVER + "/training-modules/create",
        {
          method: "POST",
          mode: "cors",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          body: JSON.stringify({
            companyId: companyId,
            userId: userId,
            title: payload.title,
            timeframeValue: payload.timeframeValue,
            timeframeUnit: payload.timeframeUnit,
            moduleReview: payload.moduleReview,
            audience: payload.audience,
            departments: payload.departments,
            locations: payload.locations,
            type: payload.type,
            points: payload.points || 0,
          }),
        }
      );
      response = await response.json();
    } catch (err) {
      return {
        status: 500,
      };
    }

    var modulePayload = context.state.modules;
    modulePayload.push({
      moduleId: response.moduleId,
      type: response.type,
      title: response.title,
      timeframeValue: response.timeframeValue,
      timeframeUnit: response.timeframeUnit,
      moduleReview: response.moduleReview,
      userId: response.userId,
      audience: response.audience,
      locations: response.locations,
      departments: response.departments,
      points: response.points || 0,
      moduleImageSource: response.moduleImageSource || null,
      lastModified: response.lastModified,
      created: response.created,
    });

    context.commit("modules", modulePayload);

    return {
      status: 201,
      moduleId: response.moduleId,
    };
  },
  // Add new learning content
  async postLearningContent(context, payload) {
    const token = context.rootGetters["authData/token"];
    const companyId = context.rootGetters["userData/companyId"];
    let response;

    let httpStatus;
    try {
      response = await fetch(
        process.env.VUE_APP_NODE_SERVER + "/learning-content/add",
        {
          method: "POST",
          mode: "cors",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          body: JSON.stringify({
            moduleId: payload.moduleId,
            companyId: companyId,
            published: payload.published,
            title: payload.title,
            type: payload.type,
            primaryLanguage:
              payload.primaryLanguage ||
              context.rootGetters["userData/selectedCulture"],
            contentId: payload.contentId,
            moduleHtml: payload.moduleHtml || null,
            moduleVideo: payload.moduleVideo || null,
            moduleFile: payload.moduleFile || null,
            quiz: payload.quiz,
          }),
        }
      );
      httpStatus = response.status;
      response = await response.json();
    } catch (err) {
      return { status: 500 };
    }

    if (httpStatus !== 201) {
      return { status: httpStatus };
    }

    var learningPayload = context.state.learningContent;
    learningPayload.push({
      learningId: response.learningId,
      moduleId: response.moduleId,
      type: response.type,
      title: response.title,
      published: response.published,
      lastModified: response.lastModified,
      contentId: response.contentId || null,
      moduleHtml: response.moduleHtml || null,
      moduleVideo: response.moduleVideo || null,
      moduleFile: response.moduleFile || null,
      quiz: response.quiz,
      created: response.created,
    });

    context.commit("learningContent", learningPayload);

    return {
      status: 201,
      learningId: response.learningId,
    };
  },
  // Add new competency test
  async postCompetencyTest(context, payload) {
    const token = context.rootGetters["authData/token"];
    const companyId = context.rootGetters["userData/companyId"];
    let response;

    try {
      response = await fetch(
        process.env.VUE_APP_NODE_SERVER + "/competency-tests/add",
        {
          method: "POST",
          mode: "cors",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          body: JSON.stringify({
            moduleId: payload.moduleId,
            companyId: companyId,
            tasks: payload.tasks,
            title: payload.title,
            type: payload.type,
            description: payload.description,
            published: payload.published,
            timeframeValue: payload.timeframeValue || 0,
            timeframeUnit: payload.timeframeUnit,
            supervisorId: payload.supervisorId,
          }),
        }
      );
      response = await response.json();
    } catch (err) {
      return { status: 500 };
    }

    let tasks = [];
    for (let i = 0; i < response.tasks.length; i++) {
      tasks.push({
        taskId: response.tasks[i].taskId,
        title: response.tasks[i].title,
      });
    }

    var competencyPayload = context.state.competencyTests;
    competencyPayload.push({
      competencyId: response.competencyId,
      moduleId: response.moduleId,
      title: response.title,
      published: response.published,
      description: response.description,
      timeframeValue: response.timeframeValue,
      timeframeUnit: response.timeframeUnit,
      supervisorId: response.supervisorId,
      tasks: tasks,
      lastModified: response.lastModified,
      created: response.created,
    });

    context.commit("competencyTests", competencyPayload);

    return {
      status: 201,
      competencyId: response.competencyId,
    };
  },
  // Uploads video file to serve
  async postUploadLearningVideo(context, payload) {
    const token = context.rootGetters["authData/token"];
    let session;
    const fileName =
      payload.learningId +
      "." +
      payload.file.type.substring(payload.file.type.lastIndexOf("/") + 1);
    const chunkSize = 6000000;
    const totalChunks = Math.ceil(Number(payload.file.size) / chunkSize);

    try {
      session = await fetch(
        process.env.VUE_APP_NODE_SERVER +
          "/learning-content/initiate-video-upload",
        {
          method: "POST",
          mode: "cors",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          body: JSON.stringify({
            fileName: fileName,
          }),
        }
      );
      session = await session.json();
      const uploadId = session.uploadId;

      let start = 0;
      let end;

      var uploadedPromises = [];
      for (let i = 0; i < totalChunks; i++) {
        end = start + chunkSize;
        var chunk = payload.file.slice(start, end);
        let fd = new FormData();
        fd.append("file", chunk);
        fd.append("fileName", fileName);
        fd.append("index", i);
        fd.append("uploadId", uploadId);

        session = await fetch(
          process.env.VUE_APP_NODE_SERVER +
            "/learning-content/upload-video-chunk",
          {
            method: "POST",
            mode: "cors",
            headers: {
              Authorization: "Bearer " + token,
            },
            body: fd,
          }
        );
        session = await session.json();
        uploadedPromises.push(session);
        start = end;
      }

      session = await fetch(
        process.env.VUE_APP_NODE_SERVER +
          "/learning-content/upload-video-complete",
        {
          method: "POST",
          mode: "cors",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          body: JSON.stringify({
            fileName: fileName,
            uploadId: uploadId,
          }),
        }
      );
      session = await session.json();
    } catch (err) {
      return { status: 500 };
    }
    session.status = 201;
    session.type = payload.file.type;
    session.size = payload.file.size;
    return session;
  },
  // Uploads pdf file to server
  async postUploadLearningPDF(context, payload) {
    const token = context.rootGetters["authData/token"];
    let session;
    const fd = new FormData();
    fd.append(
      "file",
      payload.file,
      payload.moduleId + "_file_" + String(new Date().getTime())
    );

    try {
      session = await fetch(
        process.env.VUE_APP_NODE_SERVER + "/learning-content/upload-file",
        {
          method: "POST",
          mode: "cors",
          headers: {
            Authorization: "Bearer " + token,
          },
          body: fd,
        }
      );
      session = await session.json();
    } catch (err) {
      return { status: 500 };
    }

    return {
      status: 201,
      source: session.source,
      type: session.type,
      size: session.size,
    };
  },
  // Gets all data in training
  async postEnrollment(context, payload) {
    const token = context.rootGetters["authData/token"];
    const companyId = context.rootGetters["userData/companyId"];

    let response;
    try {
      response = await fetch(
        process.env.VUE_APP_NODE_SERVER + "/training-enrollments/add",
        {
          method: "POST",
          mode: "cors",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          body: JSON.stringify({
            companyId: companyId,
            userId: payload.userId,
            moduleId: payload.moduleId,
          }),
        }
      );
      response = await response.json();
    } catch (err) {
      return {
        status: 500,
      };
    }
    let totalCompleted = 0;

    var learning = [];
    for (let i = 0; i < response.learningContent.length; i++) {
      learning.push({
        learningId: response.learningContent[i].learningId,
        status: response.learningContent[i].status,
        completedTimestamp:
          response.learningContent[i].completedTimestamp || null,
        created: response.learningContent[i].created,
      });
      if (response.learningContent[i].completedTimestamp) {
        totalCompleted = totalCompleted + 1;
      }
    }

    var competency = [];
    for (let i = 0; i < response.competencyTests.length; i++) {
      let latestTestIndex = 0;
      let lastestTestTimestamp = Number(
        response.competencyTests[i].tests[0].created
      );
      for (let j = 0; j < response.competencyTests[i].tests.length; j++) {
        if (
          Number(response.competencyTests[i].tests[j].created) >
          lastestTestTimestamp
        ) {
          latestTestIndex = j;
          lastestTestTimestamp = Number(
            response.competencyTests[i].tests[j].created
          );
        }
      }

      var tasks = [];
      for (
        let j = 0;
        j < response.competencyTests[i].tests[latestTestIndex].tasks.length;
        j++
      ) {
        tasks.push({
          taskId:
            response.competencyTests[i].tests[latestTestIndex].tasks[j].taskId,
          dateReviewed:
            response.competencyTests[i].tests[latestTestIndex].tasks[j]
              .dateReviewed,
          meetingId:
            response.competencyTests[i].tests[latestTestIndex].tasks[j]
              .meetingId,
          completedTimestamp:
            response.competencyTests[i].tests[latestTestIndex].tasks[j]
              .completedTimestamp,
        });
      }

      var attachments = [];
      for (
        let j = 0;
        j <
        response.competencyTests[i].tests[latestTestIndex].attachments.length;
        j++
      ) {
        attachments.push(
          response.competencyTests[i].tests[latestTestIndex].attachments[j]
        );
      }

      competency.push({
        competencyId: response.competencyTests[i].competencyId,
        status: response.competencyTests[i].status,
        supervisorId:
          response.competencyTests[i].tests[latestTestIndex].supervisorId,
        supervisorFullName:
          response.competencyTests[i].tests[latestTestIndex].supervisorFullName,
        completedTimestamp:
          response.competencyTests[i].tests[latestTestIndex].completedTimestamp,
        expectedReviewDate:
          response.competencyTests[i].tests[latestTestIndex].expectedReviewDate,
        tasks: tasks,
        attachments: attachments,
        comments:
          response.competencyTests[i].tests[latestTestIndex].comments || null,
        created: response.competencyTests[i].tests[latestTestIndex].created,
      });

      if (
        response.competencyTests[i].tests[latestTestIndex].completedTimestamp
      ) {
        totalCompleted = totalCompleted + 1;
      }
    }

    var enrollmentsObject = context.state.enrollments;
    enrollmentsObject.push({
      enrollmentId: response.enrollmentId,
      moduleId: response.moduleId,
      userId: response.userId,
      totalCompleted: totalCompleted,
      expectedCompletion: response.expectedCompletion,
      completedTimestamp: response.completedTimestamp || null,
      learningContent: learning,
      competencyTests: competency,
      created: response.created,
    });

    context.commit("enrollments", enrollmentsObject);

    return {
      status: 201,
      enrollment: response.enrollmentId,
    };
  },
  // PATCH Requests //

  // Update existing module
  async patchModule(context, payload) {
    const token = context.rootGetters["authData/token"];
    let response;
    const companyId = context.rootGetters["userData/companyId"];
    const userId = context.rootGetters["userData/userId"];
    try {
      response = await fetch(
        process.env.VUE_APP_NODE_SERVER + "/training-modules/update",
        {
          method: "PATCH",
          mode: "cors",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          body: JSON.stringify({
            companyId: companyId,
            userId: userId,
            moduleId: payload.moduleId,
            title: payload.title || null,
            type: payload.type || null,
            audience: payload.audience || null,
            locations: payload.locations,
            departments: payload.departments,
            timeframeValue: payload.timeframeValue || null,
            timeframeUnit: payload.timeframeUnit || null,
            moduleReview: payload.moduleReview || null,
            points: payload.points || null,
          }),
        }
      );
      response = await response.json();
    } catch (err) {
      return 500;
    }

    var modulePayload = context.state.modules;

    for (let i = 0; i < modulePayload.length; i++) {
      if (modulePayload[i].moduleId == response.moduleId) {
        modulePayload[i] = {
          moduleId: response.moduleId,
          type: response.type,
          title: response.title,
          timeframeValue: response.timeframeValue,
          timeframeUnit: response.timeframeUnit,
          moduleReview: response.moduleReview,
          userId: response.userId,
          audience: response.audience,
          locations: response.locations,
          departments: response.departments,
          points: response.points || 0,
          moduleImageSource: response.moduleImageSource || null,
          lastModified: response.lastModified,
          created: response.created,
        };
        break;
      }
    }

    context.commit("modules", modulePayload);

    return 200;
  },
  // Update existing content
  async patchLearningContent(context, payload) {
    const token = context.rootGetters["authData/token"];
    let response;
    const companyId = context.rootGetters["userData/companyId"];
    const userId = context.rootGetters["userData/userId"];
    let httpStatus;
    try {
      response = await fetch(
        process.env.VUE_APP_NODE_SERVER + "/learning-content/update",
        {
          method: "PATCH",
          mode: "cors",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          body: JSON.stringify({
            companyId: companyId,
            userId: userId,
            learningId: payload.learningId,
            published: payload.published,
            title: payload.title,
            moduleHtml: payload.moduleHtml || null,
            moduleVideo: payload.moduleVideo || null,
            quiz: payload.quiz,
          }),
        }
      );
      httpStatus = response.status;
      response = await response.json();
    } catch (err) {
      return { status: 500 };
    }

    if (httpStatus !== 200) {
      return { status: httpStatus };
    }

    var learningPayload = context.state.learningContent;

    for (let i = 0; i < learningPayload.length; i++) {
      if (learningPayload[i].learningId == response.learningId) {
        learningPayload[i] = {
          ...learningPayload[i],
          title: response.title,
          type: response.type,
          published: response.published,
          lastModified: response.lastModified,
          ...(response.contentId ? { contentId: response.contentId } : {}),
          ...(response.moduleHtml ? { moduleHtml: response.moduleHtml } : {}),
          ...(response.moduleVideo ? { moduleVideo: response.moduleVideo } : {}),
          quiz: response.quiz,
        };
        break;
      }
    }

    context.commit("learningContent", learningPayload);

    return {
      status: 200,
      learningId: response.learningId,
    };
  },
  // Update order of content
  async patchUpdateLearningContentOrder(context, payload) {
    const token = context.rootGetters["authData/token"];
    const companyId = context.rootGetters["userData/companyId"];
    let response;

    try {
      response = await fetch(
        process.env.VUE_APP_NODE_SERVER + "/learning-content/update-order",
        {
          method: "PATCH",
          mode: "cors",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          body: JSON.stringify({
            companyId: companyId,
            moduleId: payload.moduleId,
            learningIds: payload.learningIds,
          }),
        }
      );
    } catch (err) {
      return { status: 500 };
    }

    var learningPayload = context.state.learningContent;
    for (let i = 0; i < payload.learningIds.length; i++) {
      for (let j = 0; j < learningPayload.length; j++) {
        if (learningPayload[j].learningId == payload.learningIds[i]) {
          learningPayload[j].order = i;
          break;
        }
      }
    }

    context.commit("learningContent", learningPayload);

    return {
      status: 200,
      learningId: response.learningId,
    };
  },
  // Update existing competency test
  async patchCompetencyTest(context, payload) {
    const token = context.rootGetters["authData/token"];
    let response;
    const companyId = context.rootGetters["userData/companyId"];

    try {
      response = await fetch(
        process.env.VUE_APP_NODE_SERVER + "/competency-tests/update",
        {
          method: "PATCH",
          mode: "cors",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          body: JSON.stringify({
            companyId: companyId,
            competencyId: payload.competencyId,
            published: payload.published,
            title: payload.title,
            type: payload.type || null,
            description: payload.description || null,
            supervisorId: payload.supervisorId || null,
            tasks: payload.tasks || null,
            timeframeValue: payload.timeframeValue || null,
            timeframeUnit: payload.timeframeUnit || null,
          }),
        }
      );
      response = await response.json();
    } catch (err) {
      return 500;
    }

    var competencyPayload = context.state.competencyTests;

    let tasks = [];
    for (let i = 0; i < response.tasks.length; i++) {
      tasks.push({
        taskId: response.tasks[i].taskId,
        title: response.tasks[i].title,
      });
    }

    for (let i = 0; i < competencyPayload.length; i++) {
      if (competencyPayload[i].competencyId == response.competencyId) {
        competencyPayload[i] = {
          competencyId: response.competencyId,
          moduleId: response.moduleId,
          title: response.title,
          published: response.published,
          description: response.description,
          supervisorId: response.supervisorId,
          timeframeValue: response.timeframeValue,
          timeframeUnit: response.timeframeUnit,
          tasks: tasks,
          lastModified: response.lastModified,
          created: response.created,
        };
        break;
      }
    }

    context.commit("competencyTests", competencyPayload);

    return 200;
  },
  // Patch competency test in enrollment
  async patchEnrollmentCompetency(context, payload) {
    const token = context.rootGetters["authData/token"];
    const companyId = context.rootGetters["userData/companyId"];
    let response;
    try {
      response = await fetch(
        process.env.VUE_APP_NODE_SERVER +
          "/training-enrollments/update-competency-test",
        {
          method: "PATCH",
          mode: "cors",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          body: JSON.stringify({
            companyId: companyId,
            userId: payload.userId,
            enrollmentId: payload.enrollmentId,
            competencyId: payload.competencyId,
            created: payload.created,
            supervisorId: payload.supervisorId,
            tasks: payload.tasks || null,
          }),
        }
      );
      response = await response.json();
    } catch (err) {
      return 500;
    }

    if (response.completedTimestamp) {
      context.commit("enrollmentCompletedTimestamp", {
        enrollmentId: response.enrollmentId,
        completedTimestamp: response.completedTimestamp,
      });
    }

    let tasks = [];
    for (let i = 0; i < response.competencyTest.tasks.length; i++) {
      tasks.push({
        taskId: response.competencyTest.tasks[i].taskId,
        dateReviewed: response.competencyTest.tasks[i].dateReviewed || null,
        meetingId: response.competencyTest.tasks[i].meetingId || null,
        completedTimestamp:
          response.competencyTest.tasks[i].completedTimestamp || null,
      });
    }

    var enrollmentPayload = context.state.enrollments;
    for (let i = 0; i < enrollmentPayload.length; i++) {
      if (enrollmentPayload[i].enrollmentId == response.enrollmentId) {
        let competencyFound = false;
        for (let j = 0; j < enrollmentPayload[i].competencyTests.length; j++) {
          if (
            enrollmentPayload[i].competencyTests[j].competencyId ==
            response.competencyTest.competencyId
          ) {
            enrollmentPayload[i].competencyTests[j].supervisorId =
              response.competencyTest.supervisorId;
            enrollmentPayload[i].competencyTests[j].supervisorFullName =
              response.competencyTest.supervisorFullName;
            enrollmentPayload[i].competencyTests[j].status =
              response.competencyTest.status;
            enrollmentPayload[i].competencyTests[j].completedTimestamp =
              response.competencyTest.completedTimestamp;
            enrollmentPayload[i].competencyTests[j].tasks = tasks;
            competencyFound = true;
            break;
          }
        }
        if (!competencyFound) {
          enrollmentPayload[i].competencyTests.push({
            competencyId: response.competencyTest.competencyId,
            status: response.competencyTest.status,
            supervisorId: response.competencyTest.supervisorId,
            supervisorFullName: response.competencyTest.supervisorFullName,
            expectedReviewDate: response.competencyTest.expectedReviewDate,
            completedTimestamp: response.competencyTest.completedTimestamp,
            tasks: tasks,
            created: response.competencyTest.created,
          });
        }
      }
    }

    context.commit("enrollments", enrollmentPayload);
    context.commit("updateEnrollmentStatus", response.enrollmentId);

    return 200;
  },
  // Update the Learning Content
  async patchCompleteLearningContent(context, payload) {
    const token = context.rootGetters["authData/token"];
    let response;

    try {
      response = await fetch(
        process.env.VUE_APP_NODE_SERVER +
          "/training-enrollments/update-learning-content",
        {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          body: JSON.stringify({
            enrollmentId: payload.enrollmentId,
            learningId: payload.learningId,
            completedTimestamp: payload.completedTimestamp,
            companyId: payload.companyId,
          }),
        }
      );
      await response.json();
    } catch (err) {
      return { status: 500 };
    }

    let enrollmentsObject = context.state.enrollments;
    for (let i = 0; i < enrollmentsObject.length; i++) {
      if (enrollmentsObject[i].enrollmentId == payload.enrollmentId) {
        let learningFound = false;
        for (let j = 0; j < enrollmentsObject[i].learningContent.length; j++) {
          if (
            enrollmentsObject[i].learningContent[j].learningId ==
            payload.learningId
          ) {
            enrollmentsObject[i].learningContent[j].status = "completed";
            enrollmentsObject[i].learningContent[j].completedTimestamp =
              payload.completedTimestamp;
            learningFound = true;
            break;
          }
        }
        if (!learningFound) {
          enrollmentsObject[i].learningContent.push({
            learningId: payload.learningId,
            status: "completed",
            completedTimestamp: payload.completedTimestamp,
            created: String(new Date().getTime()),
          });
        }
        break;
      }
    }

    context.commit("enrollments", enrollmentsObject);

    return { status: 200 };
  },
  // Deactivate an enrollment
  async patchDeactivateEnrollment(context, enrollmentId) {
    const token = context.rootGetters["authData/token"];
    const companyId = context.rootGetters["userData/companyId"];

    try {
      await fetch(
        process.env.VUE_APP_NODE_SERVER + "/training-enrollments/deactivate",
        {
          method: "PATCH",
          mode: "cors",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          body: JSON.stringify({
            companyId: companyId,
            enrollmentId: enrollmentId,
          }),
        }
      );
    } catch (err) {
      return 500;
    }

    var enrollmentsPayload = context.state.enrollments.filter((enrol) => {
      return enrol.enrollmentId != enrollmentId;
    });

    context.commit("enrollments", enrollmentsPayload);

    return 200;
  },
  // Adds module image
  async patchModuleImage(context, payload) {
    const token = context.rootGetters["authData/token"];
    let session;
    const fd = new FormData();
    fd.append("file", payload.file, payload.moduleId);
    fd.append("moduleId", payload.moduleId);

    try {
      session = await fetch(
        process.env.VUE_APP_NODE_SERVER +
          "/training-modules/update-module-image",
        {
          method: "PATCH",
          mode: "cors",
          headers: {
            Authorization: "Bearer " + token,
          },
          body: fd,
        }
      );
      session = await session.json();
    } catch (err) {
      return { status: 500 };
    }

    var modulesPayload = context.state.modules;

    for (let i = 0; i < modulesPayload.length; i++) {
      if (modulesPayload[i].moduleId == session.module.moduleId) {
        modulesPayload[i] = session.module;
        break;
      }
    }

    context.commit("modules", modulesPayload);

    session.status = 200;
    return session;
  },

  // DELETE Requests //
  async deleteTrainingModule(context, moduleId) {
    const token = context.rootGetters["authData/token"];

    const companyId = context.rootGetters["userData/companyId"];
    try {
      await fetch(
        process.env.VUE_APP_NODE_SERVER + "/training-modules/remove",
        {
          method: "DELETE",
          mode: "cors",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          body: JSON.stringify({
            companyId: companyId,
            moduleId: moduleId,
          }),
        }
      );
    } catch (err) {
      return 500;
    }

    var modulesPayload = context.state.modules.filter((module) => {
      return module.moduleId != moduleId;
    });
    context.commit("modules", modulesPayload);

    var competencyPayload = context.state.competencyTests.filter((comp) => {
      return comp.moduleId != moduleId;
    });
    context.commit("competencyTests", competencyPayload);

    var learningPayload = context.state.learningContent.filter((learn) => {
      return learn.moduleId != moduleId;
    });
    context.commit("learningContent", learningPayload);

    var enrollmentsPayload = context.state.enrollments.filter((enrollment) => {
      return enrollment.moduleId != moduleId;
    });
    context.commit("enrollments", enrollmentsPayload);

    return 201;
  },
  // Delete competency test
  async deleteCompetencyTest(context, competencyId) {
    const token = context.rootGetters["authData/token"];
    const companyId = context.rootGetters["userData/companyId"];
    try {
      await fetch(
        process.env.VUE_APP_NODE_SERVER + "/competency-tests/remove",
        {
          method: "DELETE",
          mode: "cors",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          body: JSON.stringify({
            companyId: companyId,
            competencyId: competencyId,
          }),
        }
      );
    } catch (err) {
      return 500;
    }

    var competencyPayload = context.state.competencyTests.filter((comp) => {
      return comp.competencyId != competencyId;
    });

    context.commit("competencyTests", competencyPayload);

    return 201;
  },

  // Delete learning content
  async deleteLearningContent(context, learningId) {
    const token = context.rootGetters["authData/token"];
    const companyId = context.rootGetters["userData/companyId"];
    try {
      await fetch(
        process.env.VUE_APP_NODE_SERVER + "/learning-content/remove",
        {
          method: "DELETE",
          mode: "cors",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          body: JSON.stringify({
            companyId: companyId,
            learningId: learningId,
          }),
        }
      );
    } catch (err) {
      return 500;
    }

    var learningPayload = context.state.learningContent.filter((learn) => {
      return learn.learningId != learningId;
    });

    context.commit("learningContent", learningPayload);

    return 201;
  },

  deleteItemsByModule(context, moduleId) {
    var enrollmentsPayload = context.state.enrollments.filter((enrollment) => {
      enrollment.moduleId != moduleId;
    });
    context.commit("enrollments", enrollmentsPayload);

    var competencyPayload = context.state.competencyTests.filter((test) => {
      test.moduleId != moduleId;
    });
    context.commit("competencyTests", competencyPayload);

    var learningPayload = context.state.learningContent.filter((learning) => {
      learning.moduleId != moduleId;
    });
    context.commit("learningContent", learningPayload);

    return;
  },
  // Delete learning content
  removeRequiredAction(context, actionId) {
    context.commit("removeRequiredAction", actionId);
  },
  // Reset
  trainingTimestampReset(context) {
    context.commit("trainingTimestampReset");
  },
};
